import useAvailablePlatformComponents from './use-available-platform-components';

export default {
  useAvailablePlatformComponents,
};
